import React, { FC } from "react";
import { BulletSectionTitle } from "../../../../../components/section/BulletSectionTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { cn } from "../../../../../components/utils/cn";
import MagicIcon from "../../../../../assets/magic_icon.png";

interface AccordionSectionProps {
  title: string;
  subtitle?: string;
  expanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  className?: string;
  isMagic?: boolean;
  hideBottomBorder?: boolean;
}

const AccordionSection: FC<AccordionSectionProps> = ({
  title,
  subtitle,
  expanded,
  onToggle,
  children,
  className,
  isMagic,
  hideBottomBorder,
}) => {
  return (
    <div className={cn("transition-all duration-300 ease-in-out", className)}>
      {isMagic ? (
        <div
          className="py-2 flex flex-row gap-2 items-center flex-1 min-w-0 cursor-pointer rounded-2xl lg:hover:bg-gray-2 active:lg:bg-gray-3 active:scale-95 transition-all duration-200"
          onClick={onToggle}
        >
          <img src={MagicIcon} className="w-6 h-6" alt="Magic Icon" />
          <div className="flex flex-col text-left">
            <p className="text-xs font-black text-black">{title}</p>
            <p className={cn("text-xs text-gray-6 font-normal break-words")}>
              {subtitle}
            </p>
          </div>

          <FontAwesomeIcon
            icon={expanded ? faChevronUp : faChevronDown}
            className="w-3 h-3 text-black flex-shrink-0"
          />
        </div>
      ) : (
        <div
          className="p-2 flex items-center justify-between cursor-pointer gap-2 rounded-2xl lg:hover:bg-gray-2 active:lg:bg-gray-3 active:scale-95 transition-all duration-200"
          onClick={onToggle}
        >
          <div className="flex flex-col flex-1 min-w-0">
            <BulletSectionTitle>
              {title}
              {subtitle && (
                <p
                  className={cn("text-xs text-gray-6 font-normal break-words")}
                >
                  {subtitle}
                </p>
              )}
            </BulletSectionTitle>
          </div>

          <FontAwesomeIcon
            icon={expanded ? faChevronUp : faChevronDown}
            className="w-3 h-3 text-black flex-shrink-0"
          />
        </div>
      )}

      <div
        className={cn(
          "overflow-hidden transition-all duration-300 ease-in-out flex flex-col gap-1 pt-2",
          expanded
            ? "max-h-[500px] opacity-100" // max-h can be adjusted based on the maximum expected content height
            : "max-h-0 opacity-0",
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default AccordionSection;
